import { Log } from "../interfaces/logs";
import { createDBServiceSlice } from "./db-service-reducers"; // Add missing import statement
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "./store";
import moment from "moment";

export const {
    slice: LogsSlice,
    dbThunks: _LogsThunks,
    selectByQuery: _logsSelectByQuery,
    selectOneObjectByQuery: _logsSelectOneObjectByQuery,
    selectOneFieldByQuery: _logsSelectOneFieldByQuery,
    selectors: _logsSelectors,
    selectByQueryOnlyLength: _logsSelectByQueryOnlyLength,
    selectByQueryOnlyMaxMin: _logsSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<Log>({
    service: "logs",
    initialState: { ids: [], entities: {}, itemsLoaded: false, itemsLoading: false },
    getReducerState: (state) => state.DBLogsReducer,
});
export const DBLogsReducer = LogsSlice.reducer;
export const LogsReducerActions = LogsSlice.actions;
export type logsReducerActions = keyof typeof LogsReducerActions;
export const DBLogsThunks = _LogsThunks;
export const logsSelectors = _logsSelectors;
export const logsSelectByQuery = _logsSelectByQuery;
export const logsSelectByQueryOnlyLength = _logsSelectByQueryOnlyLength;
export const logsSelectByQueryOnlyMaxMin = _logsSelectByQueryOnlyMaxMin;
export const logsSelectOneObjectByQuery = _logsSelectOneObjectByQuery;
export const logsSelectOneFieldByQuery = _logsSelectOneFieldByQuery;

export interface ConnectionSegment {
    feedTag: string;
    channelTag: string;
    connectedAt: Date;
    disconnectedAt?: Date;
}


const groupLogsByConnection = (logs: Log[]): ConnectionSegment[] => {
    const segments: ConnectionSegment[] = [];
    const connections: Record<string, ConnectionSegment> = {};

    logs.forEach(log => {
        if (log.feedTag && log.channelTag) {
            const key = `${log.feedTag}-${log.channelTag}`;

            if (log.type === 'connectTrafficChannel' || log.type === 'connectRedTrackOffer') {
                connections[key] = { feedTag: log.feedTag, channelTag: log.channelTag, connectedAt: new Date(log.createdAt) };
            } else if (log.type === 'disconnectTrafficChannel' && connections[key]) {
                connections[key].disconnectedAt = new Date(log.createdAt);
                segments.push(connections[key]);
                delete connections[key];
            }
        }
    });

    // Add ongoing connections without a disconnect log
    Object.values(connections).forEach(segment => {
        if (!segment.disconnectedAt) {
            segment.disconnectedAt = new Date();
        } else {
            segment.disconnectedAt = new Date(segment.disconnectedAt); // Convert to date object
        }
        segment.connectedAt = new Date(segment.connectedAt); // Convert to date object
        segments.push(segment);
    });

    return segments;
};

export const selectGroupedLogsByConnection = createSelector(
    (state: RootState) => logsSelectByQuery(state.DBLogsReducer, {}),
    (logs) => {
        return groupLogsByConnection(logs);
    }
);


export const selectLatestSuccessfulImportTime = createSelector(
    (state: RootState) => logsSelectByQuery(state.DBLogsReducer, { 
        type: 'statsRefresh',
    }, null, { createdAt: -1 }),
    (logs) => {
        const log = logs.find(log => log.message.includes('Finished data import'))
        return log ? moment(log.createdAt) : null;
    }
);

export const selectIsImportInProgress = createSelector(
    (state: RootState) => logsSelectByQuery(state.DBLogsReducer, { 
        type: 'statsRefresh',
    }, null, { createdAt: -1 }),
    (logs) => {
        const lastLog = logs[0];
        return lastLog ? !lastLog.message.includes('Finished data import') : false;
    }
);